import { OptionButtons, OptionButtonsPropsBase } from "Components/OptionButtons"
import { PurchaseOrder } from "Features/pages/purchaseOrders/types/PurchaseOrder.interfaces"
import { isPurchaseOrderEditable } from "Features/pages/purchaseOrders/types/utils/helper.util"
import { AuthzService } from "Shared/services"

export const PurchaseOrderOptionButtons = <T extends Pick<PurchaseOrder, "state" | "deleted" | "requestedBy" | "createdBy">>({
    record,
    onEdit,
    onDelete,
    onView,
    children,
}: OptionButtonsPropsBase<T>) => {
    // Check if the current user can edit this purchase order
    const isEditDisabled = !isPurchaseOrderEditable(record)
    const isDeleteDisabled = !AuthzService.isLoggedInUserAllowedToDeletePurchaseOrder(record)

    return OptionButtons<T>({ record, onEdit, onDelete, onView, children, isEditDisabled, isDeleteDisabled })
}
